<template>
  <div class="sb-checkbox">
    <label class="form-check-label">
      <input class="form-check-input"
              type="checkbox"
              v-bind:id="check.Name"
              v-model="check.Checked"
              @input="$emit('setCheckBox', check)">
      <span class="checkmark"></span>
    </label>
  </div>
</template>
<script>
  export default {
    name: 'SbCheckboxOld',
    props: {
      check: {
        type: Object,
        required: true
      }
    }
  }
</script>
<style lang="scss" scoped>

    .sb-checkbox input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
      position: absolute;
      top: 1px;
      left: 0px;
      height: 16px;
      width: 16px;
      background: #ffffff;
      border: 1px solid rgba(36, 112, 175, 1);
      box-shadow: inset 0 1px 2px 0 rgba(52,62,79,.1);
      border-radius: 3px;

      &:focus,
      &.focus,
      &:active,
      &.active {
        box-shadow: 0px 0px 0px 2px rgba(36, 112, 175, 1);
        border-color: transparent;
      }
    }

    /* Create the indicator (the dot/circle - hidden when not checked) */
    .checkmark:after {
      content: "";
      position: absolute;
      display: none;
    }

    /* Show the indicator (dot/circle) when checked */
    .form-check-label input.form-check-input:checked ~ .checkmark:after {
      display: block;
    }

    /* Style the indicator (dot/circle) */
    .form-check-label .checkmark:after {
      top: 0px;
      left: 4px;
      width: 6px;
      height: 11px;
      border: solid rgba(36, 112, 175, 1);
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }


</style>
